import {ActionBuilder} from "@cuatroochenta/co-redux-builders";

export default ActionBuilder.build({
    setPassword: (password: string) => password,
    setRePassword: (rePassword: string) => rePassword,
    clearReducer: () => ({}),
});
